import { render, staticRenderFns } from "./SettingsWrapper.vue?vue&type=template&id=7952c781&"
import script from "./SettingsWrapper.vue?vue&type=script&lang=js&"
export * from "./SettingsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports